import { render, staticRenderFns } from "./Plain.vue?vue&type=template&id=4314db06&"
import script from "./Plain.vue?vue&type=script&lang=js&"
export * from "./Plain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports